import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { DashboardTimeframe } from '../../domain/enums/dashboard-timeframe.enum';
import { DashboardPreferencesResponseDto } from '../dtos/dashboard-preferences-response.dto';
import { DashboardWidgetDataResponseDto } from '../dtos/dashboard-widget-data-response.dto';
import { DashboardWidgetResponseDto } from '../dtos/dashboard-widget-response.dto';
import { UpdateDashboardPreferencesRequestDto } from '../dtos/update-dashboard-preferences-request.dto';

@Injectable({ providedIn: 'root' })
export class DashboardApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _baseUrl = `${this._config.versionedApiUrl}/cases/dashboard`;

  public getMe(): Observable<DashboardPreferencesResponseDto> {
    return this._http.get<DashboardPreferencesResponseDto>(`${this._baseUrl}/me`);
  }

  public getWidgets(): Observable<DashboardWidgetResponseDto[]> {
    return this._http.get<DashboardWidgetResponseDto[]>(`${this._baseUrl}/widgets`);
  }

  public getWidgetData(
    widgetId: string,
    timeframe?: DashboardTimeframe,
  ): Observable<DashboardWidgetDataResponseDto> {
    let params = new HttpParams();
    if (timeframe !== undefined) params = params.set('timeframe', timeframe);
    return this._http.get<DashboardWidgetDataResponseDto>(
      `${this._baseUrl}/widgets/${widgetId}/data`,
      { params },
    );
  }

  public updatePreferences(request: UpdateDashboardPreferencesRequestDto): Observable<void> {
    return this._http.put<void>(`${this._baseUrl}/preferences`, request);
  }
}
